import { LoadingButton } from "@mui/lab";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import { updateMe } from "api/auth";
import useAPICall from "hooks/useAPICall";
import useAuth from "hooks/useAuth";
import { useEffect, useState } from "react";

type Props = {
  open: boolean;
  onClose: () => void;
};

export const NameChangeModal = ({ open, onClose }: Props) => {
  const { currentName, me } = useAuth();
  const [name, setName] = useState("");

  const { callAPI, sending, makeSendData, generalErrorMessage, errorMode } = useAPICall({
    apiMethod: updateMe,
    successMessage: () => "名前を更新しました",
    failedMessage: () => "更新に失敗しました",
    onSuccess: () => {
      me();
      onClose();
    },
  });

  useEffect(() => {
    if (open && currentName) {
      setName(currentName);
    }
  }, [open, currentName]);

  const handleUpdate = async () => {
    await callAPI(
      makeSendData({
        name,
      })
    );
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>名前変更</DialogTitle>
      <DialogContent>
        {errorMode === "server" && generalErrorMessage && (
          <div style={{ color: "red", marginBottom: "16px" }}>{generalErrorMessage}</div>
        )}
        <TextField
          autoFocus
          margin="dense"
          label="名前"
          fullWidth
          variant="outlined"
          value={name}
          onChange={(e) => setName(e.target.value)}
          disabled={sending}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={sending}>
          キャンセル
        </Button>
        <LoadingButton
          onClick={handleUpdate}
          variant="contained"
          loading={sending}
          disabled={!name}
        >
          更新
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};
